import { 
    gql, 
    useMutation 
} from "@apollo/client";
import React, { ReactElement } from "react";
import { 
    CreateCategoryMutationMutation,
    CreateCategoryMutationMutationVariables 
} from "../../../../../schemaTypes";

import { normalizeErrors } from "../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";

export const createCategoryMutation = gql`
  mutation CreateCategoryMutation(
        $name: String!
        $imgSrc: String!
    ) {
        createCategory(
            name: $name
            imgSrc: $imgSrc
            ) {
            errors {
                path
                message
            }
            message
            imgSrcUrl
        }
  }
`;

interface Props {
  children: (
    data: {
      submitCreateCategory: (
        values: CreateCategoryMutationMutationVariables & {
          imgSrcFile?: File;
        }
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      createCategoryData: any | null; 
    }
  ) => ReactElement | null;
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const CreateCategoryController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    CreateCategoryMutationMutation,
    CreateCategoryMutationMutationVariables
  >(
    createCategoryMutation
  );

  const submitCreateCategory = async (values: CreateCategoryMutationMutationVariables & { imgSrcFile?: File }) => {
    const { imgSrcFile, ...rest } = values;
    let imgSrcUrl = rest.imgSrc;
    if (imgSrcFile) {
     imgSrcUrl = await fileToBase64(imgSrcFile);
    }

    const { data: {createCategory} }:any = await mutate({ 
      variables: {
        ...rest,
        imgSrc: imgSrcUrl
      }
    });

    if (createCategory?.errors) {
      return {error: normalizeErrors(createCategory.errors), createCategory: null};
    }

    return {
      error: null,
      createCategory,
      imgSrcUrl: data?.createCategory?.imgSrcUrl
    };
  };

  const message = data?.createCategory?.message || null;

  return children({
    submitCreateCategory,
    loading,
    error,
    message,
    createCategoryData: data,
  });
};